/* eslint-disable @nx/enforce-module-boundaries */
import {
  FormControl,
} from '@mybridge/ui';
import React, { useState, useEffect } from 'react';
import { Input} from '@mybridge/ui/input';
import {VStack } from '@mybridge/ui/layout';
import { TagsInput } from '../tags-input';
import { Box } from '@chakra-ui/react';
import { EmailDropdown } from '../email-dropdown';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const WebsitesTagsInput = ({
  value,
  onChange,
  placeholder = 'Add Website',
  keyName = 'Website',
  round = true,
  ...props
}) => {
  const { t } = useTranslator();
  const [websiteList, setWebsiteList] = useState(Array.isArray(value) ? value : []); // Ensure emailList is an array
  useEffect(() => {
    if (Array.isArray(value)) {
      setWebsiteList(value);
    }
  }, [value]);
  // Email validation
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  // Handle adding a valid email
  const handleAddWebsites = (emailToAdd) => {
    if (validateEmail(emailToAdd) && !websiteList.includes(emailToAdd)) {
      const newEmailList = [...websiteList, emailToAdd];
      setWebsiteList(newEmailList);
      onChange(newEmailList)
    }
  };
const handleAddWebsite=(ee)=>{
  setWebsiteList(ee)
  onChange(ee)
}
  return (
    <VStack alignItems="flex-start" w="100%">
      <Box>
        <FormControl>
          {/* <FormLabel>Email</FormLabel> */}
          <TagsInput
            title="website"
            value={websiteList}
            onChange={(e) => handleAddWebsite(e)}
          >
            {({ addTag, setEdit }) => (
              <EmailDropdown
                allowCreate
                website={true}
                onChange={(obj) => {
                  handleAddWebsites(obj?.name)
                  addTag?.(obj?.name);
                  setEdit(false);
                }}
              
              >
                {(input) => (
                  <Input
                    {...(input ?? {})}
                    borderRadius="full"
                    onClick={(e) => input?.disc?.onOpen?.()}
                    onChange={(e) => input?.onChange(e.target.value)}
                    placeholder={t('otherModules.enterWebsite') || "Enter website"}
                    onKeyUp={(e) => {
                      input?.onKeyUp?.(e);
                      if (e.keyCode === 27) {
                        setEdit(false);
                      }
                    }}
                    autoFocus
                  />
                )}
              </EmailDropdown>
            )}
          </TagsInput>
        </FormControl>
      </Box>
    </VStack>
  );
};
